import { render, staticRenderFns } from "./detail-fan.vue?vue&type=template&id=01360ef1&scoped=true&"
import script from "./detail-fan.vue?vue&type=script&lang=js&"
export * from "./detail-fan.vue?vue&type=script&lang=js&"
import style0 from "./detail-fan.vue?vue&type=style&index=0&id=01360ef1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01360ef1",
  null
  
)

export default component.exports